import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Table, Tag, Button, Typography, Input, Space } from 'antd';
import { EyeOutlined, SearchOutlined, FileProtectOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { clientService } from '../../../common/services';
import Loader from '../../../components/loader/Loader';
import moment from 'moment';

const { Title } = Typography;

export default function MesContrats() {
    const navigate = useNavigate();
    const [contrats, setContrats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');

    useEffect(() => {
        loadContrats();
    }, []);

    const loadContrats = async () => {
        try {
            const resp = await clientService.getContrats();
            if (resp.success) {
                setContrats(resp.data);
            }
        } catch (error) {
            toast.error('Erreur lors du chargement des contrats');
        } finally {
            setLoading(false);
        }
    };

    const filtered = contrats.filter(c =>
        !search || c.numeroPolice?.toLowerCase().includes(search.toLowerCase()) ||
        c.compagnie?.nom?.toLowerCase().includes(search.toLowerCase()) ||
        c.typeAssurance?.nom?.toLowerCase().includes(search.toLowerCase())
    );

    const columns = [
        {
            title: 'N. Police',
            dataIndex: 'numeroPolice',
            key: 'police',
            render: (text) => <strong>{text}</strong>,
        },
        {
            title: 'Compagnie',
            dataIndex: ['compagnie', 'nom'],
            key: 'compagnie',
        },
        {
            title: 'Type',
            dataIndex: ['typeAssurance', 'nom'],
            key: 'type',
        },
        {
            title: 'Date effet',
            dataIndex: 'dateEffet',
            key: 'effet',
            render: (d) => moment(d).format('DD/MM/YYYY'),
        },
        {
            title: 'Echeance',
            dataIndex: 'dateEcheance',
            key: 'echeance',
            render: (d) => moment(d).format('DD/MM/YYYY'),
        },
        {
            title: 'Prime TTC',
            dataIndex: 'primeTTC',
            key: 'prime',
            render: (v) => `${(v || 0).toLocaleString()} FCFA`,
        },
        {
            title: 'Statut',
            dataIndex: 'statut',
            key: 'statut',
            render: (s) => {
                const colors = { actif: 'green', expire: 'red', resilie: 'default', renouvele: 'blue' };
                return <Tag color={colors[s] || 'default'}>{s}</Tag>;
            },
        },
        {
            title: '',
            key: 'actions',
            width: 80,
            render: (_, record) => (
                <Button
                    type="link"
                    icon={<EyeOutlined />}
                    onClick={() => navigate(`/espace-client/contrats/${record._id}`)}
                >
                    Detail
                </Button>
            ),
        },
    ];

    if (loading) return <Loader />;

    return (
        <div>
            <Title level={3}>
                <FileProtectOutlined style={{ marginRight: 8 }} />
                Mes contrats
            </Title>

            <Card>
                <Space style={{ marginBottom: 16 }}>
                    <Input
                        placeholder="Rechercher un contrat..."
                        prefix={<SearchOutlined />}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{ width: 300 }}
                        allowClear
                    />
                </Space>

                <Table
                    dataSource={filtered}
                    columns={columns}
                    rowKey="_id"
                    pagination={{ pageSize: 10 }}
                    scroll={{ x: 800 }}
                    locale={{ emptyText: 'Aucun contrat trouve' }}
                />
            </Card>
        </div>
    );
}
